import React, { Component, PropTypes } from 'react'
import ChipInput from 'material-ui-chip-input'
import { without, find } from 'lodash'

import api from '../../api'

class TagSelector extends Component<any, any> {
  state = {
    tags: null
  }

  componentWillMount () {
    const options = this.props.includeUnused
      ? { body: { filters: { include_unused: true } } }
      : undefined

    api.get('admin/tags', options)
      .then(res => res.json())
      .then(tags => {
        this.setState({ tags })
      })
  }

  handleChipInputAdd = chip => {
    const newValue = (this.props.value || []).concat(chip.value)
    this.props.onChange(null, newValue)
  }

  handleChipInputDelete = value => {
    const newValue = without(this.props.value, value)
    this.props.onChange(null, newValue)
  }

  render () {
    const { tags } = this.state

    if (tags === null) {
      return <div />
    }

    const values = (this.props.value || []).map(value => {
      const existing = find(tags, { value })
      return existing || { name: value, value }
    })

    return (
      <div>
        <ChipInput
          floatingLabelText={this.props.label}
          onRequestAdd={this.handleChipInputAdd}
          onRequestDelete={this.handleChipInputDelete}
          dataSource={tags}
          dataSourceConfig={{ text: 'value', value: 'value' }}
          value={values}
          errorText={this.props.errorText}
          openOnFocus
          fullWidth
        />
      </div>
    )
  }
}

// @ts-ignore
TagSelector.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  includeUnused: PropTypes.bool
}

// @ts-ignore
TagSelector.defaultProps = {
  value: [],
  errorText: null
}

export default TagSelector
